"use client";

import React from "react";
import { X, Trash2 } from "lucide-react";

interface ConfirmDeleteCommunityJoydropProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

const ConfirmDeleteCommunityJoydrop: React.FC<ConfirmDeleteCommunityJoydropProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting = false,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/30 z-50 text-black p-4 overflow-auto"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-delete-title"
    >
      <div
        className="w-full max-w-[min(440px,95vw)] bg-white rounded-[8px] border-asymmetric border-[#151515] shadow-lg flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-3 sm:p-4 border-b border-gray-100 bg-gray-50/50 flex items-center justify-between flex-shrink-0">
          <h2 id="confirm-delete-title" className="text-sm sm:text-base font-bold text-gray-900 fraunces-display">
            Delete community joydrop?
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="p-1 rounded hover:bg-gray-200 transition-colors text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            <X size={20} strokeWidth={2} />
          </button>
        </div>
        <div className="p-4 sm:p-5 flex flex-col gap-4">
         
          <div className="flex items-center justify-center w-14 h-14 bg-red-100 rounded-full mx-auto">
            <Trash2 size={28} className="text-red-600" strokeWidth={2} />
          </div>
          <p className="text-center text-base sm:text-lg font-bold text-gray-900 fraunces-display">
            Are you sure you want to delete this joydrop?
          </p>
          <p className="text-center text-sm text-gray-800 font-medium space-mono-text">
            This will permanently remove the joydrop from the community feed. Members will no longer see it. This action cannot be undone.
          </p>
          <div className="flex gap-3 mt-2">
            <button
              type="button"
              onClick={onClose}
              disabled={isDeleting}
              className="flex-1 h-11 flex items-center justify-center px-4 py-3 text-sm font-montserrat font-bold text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-[6px] border-2 border-[#151515] shadow-[2px_2px_0px_0px_rgba(21,21,21,1)] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isDeleting}
              className="flex-1 h-11 flex items-center justify-center px-4 py-3 text-sm font-montserrat font-bold text-white bg-red-600 hover:bg-red-700 rounded-[6px] border-2 border-[#151515] shadow-[2px_2px_0px_0px_rgba(21,21,21,1)] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isDeleting ? "Deleting…" : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteCommunityJoydrop;
